import { COLORS } from "../../../common/consts/colors";
import type { IconProps } from "./type";

export default function KidsFriendlyIcon({ color = "lightblack" }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M20 9C20 4.2 16 3 14 3V9M20 9C20 13 16 14 14 14H12C10 14 6 13 6 9M20 9H14M6 9V5H4M6 9H14M20 19C20 20.1046 19.1046 21 18 21C16.8954 21 16 20.1046 16 19C16 17.8954 16.8954 17 18 17C19.1046 17 20 17.8954 20 19ZM10 19C10 20.1046 9.10457 21 8 21C6.89543 21 6 20.1046 6 19C6 17.8954 6.89543 17 8 17C9.10457 17 10 17.8954 10 19Z"
        stroke={COLORS[color]}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
